import React, { useEffect, useState } from "react";
import apiClient from "../../utils/apiclient";

const Index = () => {
  const isAdmin = localStorage.getItem("bentoAdminDetails") == 4 ? true : false;
  const [data, setData] = useState([]);
  const [editRow, setEditRow] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [newContainerData, setnewContainerData] = useState({});
  const [newContainer,SetnewConatiner]= useState(false);
  useEffect(() => {
    const fetchdata = async () => {
      try {
        const response = await apiClient.get("/container");
        setData(response.data);
      } catch (e) {
        console.log(e);
      }
    };
    fetchdata();
  }, []);

  const handleEditClick = (row) => {
    setEditRow(row.id);
    setEditedData({ ...row });
  };

  const handleChange = (e, field) => {
    setEditedData({ ...editedData, [field]: e.target.value });
  };
   const handlenewChange = (e, field) => {
    setnewContainerData({ ...newContainerData, [field]: e.target.value });
  };

  const handleSave = async() => {

    try{
      const formdata = await apiClient.put(
  `/editcontainer?id=${editedData.id}&name=${editedData.name}&price=${editedData.price}`);
  console.log(formdata.data);
  

    }
    catch(e){
      console.log(e);
      
    }
    const updatedData = data.map((item) =>
      item.id === editedData.id ? editedData : item
    );
    setData(updatedData);

   

    setEditRow(null);
  };
  const handleAdd=async()=>{
     try{
      const formData =new FormData();
      formData.append("name",newContainerData.name)
      formData.append("price",parseInt(newContainerData.price))
      const response = await apiClient.post("/container", formData,{
         headers: {
        "Content-Type": "multipart/form-data",
      },
      });
    console.log(response.data);
        const updatedResponse = await apiClient.get("/container");
    setData(updatedResponse.data);

    }
    catch(e){
      console.log(e);
      
    }
   

    
    console.log(newContainerData);
    
  }

  return (
    <div className="w-full flex-1 flex flex-col min-h-0 mt-4">
      <div className="flex justify-between items-center mb-2 flex-shrink-0">
        <h2 className="text-xl font-bold text-gray-800">Edit Containers</h2>
      </div>

      <div className="w-full flex-1 overflow-auto pb-4 relative">
        <table className="min-w-max w-full bg-white shadow-md border-collapse">
          <thead className="bg-gray-800 text-white sticky top-0 z-20 shadow-md">
            <tr>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Container Id</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Container Name</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Container Price</th>
              { (isAdmin) && (
                <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-left">Edit</th>
              )}
            </tr>
          </thead>
          <tbody>
          {data.map((row, index) => (
            <tr
              key={index}
              className="border-b border-gray-300 hover:bg-gray-50 transition"
            >
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">{row.id}</td>

              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">
                {editRow === row.id ? (
                  <input
                    type="text"
                    value={editedData.name}
                    onChange={(e) => handleChange(e, "name")}
                    className="border px-2 py-1 rounded"
                  />
                ) : (
                  row.name
                )}
              </td>

              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">
                {editRow === row.id ? (
                  <input
                    type="number"
                    value={editedData.price}
                    onChange={(e) => handleChange(e, "price")}
                    className="border px-2 py-1 rounded"
                  />
                ) : (
                  row.price
                )}
              </td>
{isAdmin && (
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-gray-800">
                {editRow === row.id ? (
                  <button
                    onClick={handleSave}
                    className="bg-green-500 text-white px-3 py-1 rounded"
                  >
                    Save
                  </button>
                ) : (
                  <button
                    onClick={() => handleEditClick(row)}
                    className="bg-blue-500 text-white px-3 py-1 rounded"
                  >
                    Edit
                  </button>
                )}
              </td>
)}
            </tr>
          ))}
        </tbody>
      </table>
      </div>
      {(isAdmin) && (
      <div className="flex-shrink-0 mt-4 mb-4 border-t pt-4">
        <button className="bg-blue-500 hover:bg-blue-600 transition text-white px-4 py-2 rounded font-medium"
                    onClick={()=>SetnewConatiner(!newContainer)}>
                      Add new Container
        </button>
        {newContainer? <div className="mt-4 flex flex-wrap items-center gap-2">
          <input
          type="text"
          placeholder="Container name"
          className="border-2 border-indigo-600 text-center px-2 py-1"
          onChange={(e) => handlenewChange(e, "name")}
          
          
        />
          <input
          type="number"
          placeholder="Container price"
          className="border-2 border-indigo-600 text-center px-2 py-1"
            onChange={(e) => handlenewChange(e, "price")}
          
        />
        <button
        
          className="bg-blue-500 hover:bg-blue-600 transition text-white px-4 py-1 rounded font-medium"
        onClick={handleAdd}
        >
          Add
        </button>
        </div>:""}
      </div>
      )}
    </div>
  );
};

export default Index;
